import * as types from '@/store/filters/actionTypes';
import {
  CLEAR_ORGANIZATION_FILTER,
  SET_DOMAIN_FILTER,
  SET_DATE_FILTER, SET_TYPE_FILTER, SET_REPORTS_DATE_FILTER, CLEAR_DOMAIN_FILTER, SET_ORGANIZATION_FILTER,
} from '@/store/filters/mutationTypes';
// eslint-disable-next-line import/no-cycle

export default {
  async [types.CLEAR_DOMAIN_FILTER]({ commit }) {
    await commit(CLEAR_DOMAIN_FILTER);
  },
  async [types.CLEAR_ORGANIZATION_FILTER]({ commit }) {
    await commit(CLEAR_ORGANIZATION_FILTER);
  },
  async [types.SET_DOMAIN_FILTER]({ commit }, value) {
    await commit(SET_DOMAIN_FILTER, value);
  },
  async [types.SET_TYPE_FILTER]({ commit }, value) {
    await commit(SET_TYPE_FILTER, value);
  },
  async [types.SET_DATE_FILTER]({ commit }, value) {
    await commit(SET_DATE_FILTER, value);
  },
  async [types.SET_REPORTS_DATE_FILTER]({ commit }, value) {
    await commit(SET_REPORTS_DATE_FILTER, value);
  },
  async [types.SET_ORGANIZATION_FILTER]({ commit, getters }, value) {
    if (value && (value.length > 0 || Object?.keys(value)?.length > 0)) {
      let domains;
      if (!value?.organizations) {
        await commit(SET_ORGANIZATION_FILTER, value);
        domains = [];
        value.forEach(org => {
          const defaultDomain = getters.organizations.find(item => org === item.name)?.domain || '';
          if (defaultDomain && defaultDomain !== '') {
            domains.push(defaultDomain);
          }
        });
      } else {
        const domainFilter = value?.domainFilter;
        const organizations = Object.values(value?.organizations);
        const organizationFilter = Object.values(value?.organizationFilter);
        await commit(SET_ORGANIZATION_FILTER, organizations);
        domains = domainFilter;
        if (organizations.length > organizationFilter.length) {
          const changedOrganizations = organizations.filter(item => !organizationFilter.includes(item));
          changedOrganizations.forEach(org => {
            const defaultDomain = getters.organizations.find(item => org === item.name)?.domain || '';
            if (defaultDomain && defaultDomain !== '') {
              domains.push(defaultDomain);
            }
          });
        } else {
          const changedOrganizations = organizationFilter.filter(item => !organizations.includes(item));
          const removedDomains = [];
          changedOrganizations.forEach(org => {
            const orgDomains = [...getters.domainsPerOrganization.get(org), ...getters.cloudAccountsPerOrganization.get(org)];
            domainFilter.forEach(domain => {
              if (orgDomains.includes(domain)) {
                removedDomains.push(domain);
              }
            });
          });
          domains = domainFilter.filter(item => !removedDomains.includes(item));
        }
      }
      await commit(SET_DOMAIN_FILTER, Array.from(new Set(domains)));
    } else {
      await commit(CLEAR_DOMAIN_FILTER);
    }
  },
};
